export const LISTENING_GUIDELINES = {
  "Summarize Spoken Text":
    "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 50 - 70 words. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.",
  "Listening: Multiple Choice, Multiple Answers":
    "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.",
  "Fill in the Blanks":
    "You will hear a recording. Type the missing words in each blank.",
  "Highlight Correct Summary":
    "You will hear a recording. Click on the paragraph that best relates to the recording.",
  "Listening: Multiple Choice, Single Answer":
    "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.",
  "Select Missing Word":
    "You will hear a recording. At the end of the recording the last word or group of words has been replaced by a beep. Select the correct option to complete the recording.",
  "Highlight Incorrect Words":
    "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.",
  "Write from Dictation":
    "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.",
};

export const END_MODAL_SENTENCES = [
  "Please wait while your result is being processed",
  "Compiling your result ...",
  "Almost there ...",
  "Adding final touches ...",
];

export const GLOBAL_ENDING_LINES = [
  "Thanks for taking the test. Your performance helps us personalize your practice.",
  "Tip: Review weak areas in the score page to improve faster.",
  "You can revisit incomplete sectionals anytime from the Mock Tests page.",
];
